import { render, staticRenderFns } from "./FreestylerInfoModal.vue?vue&type=template&id=bbcf0964"
import script from "./FreestylerInfoModal.vue?vue&type=script&lang=js"
export * from "./FreestylerInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports